import { SafeAreaView as SAV } from 'react-native-safe-area-context';
import { ViewStyle } from 'react-native';
import styled from 'styled-components/native';
import React from 'react';

function BaseSafeAreaView({ children, style }: { children?: any; style?: ViewStyle }) {
  return <Component style={style}>{children}</Component>;
  /*
  const insets = useSafeAreaInsets();
  return (
    <Component top={insets.top} bottom={insets.bottom} style={style}>
      {children}
    </Component>
  ); */
}

const Component = styled(SAV)`
  flex: 1;
  background-color: transparent;
`;

export const SafeAreaView = React.memo(BaseSafeAreaView);
